import * as React from "react";
import {
  makeStyles
} from "@fluentui/react-components";

const useStyles = makeStyles({
    centeredContent: {
        display: "flex",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignContent: "center"
    }
});

export const CenteredContent: React.FC<React.PropsWithChildren> = (props) => {
    const styles = useStyles();
    
    return (
        <div className={styles.centeredContent}>
            { props.children }
        </div>
    );
};